export enum ErrorCode {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND',
  INVALID_PASSWORD_CHANGE_CODE = 'INVALID_PASSWORD_CHANGE_CODE',
  PASSWORD_RESET_LINK_EXPIRED = 'PASSWORD_RESET_LINK_EXPIRED',
  UNKNOWN = 'UNKNOWN_ERROR',
  CHECK_THE_ENVIRONMENT_ADMIN = 'CHECK_THE_ENVIRONMENT_ADMIN',
  CHECK_THE_ENVIRONMENT_EXPERT = 'CHECK_THE_ENVIRONMENT_EXPERT',
  NO_PERMISSION_ACCESS_PANEL_EXPERT = 'NO_PERMISSION_ACCESS_PANEL_EXPERT'
}
